import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface BrutalInputProps extends InputHTMLAttributes<HTMLInputElement> {}

const BrutalInput = forwardRef<HTMLInputElement, BrutalInputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "w-full border-[3px] border-dark p-3 font-body text-base bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-4 focus:ring-primary transition-all disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

BrutalInput.displayName = "BrutalInput";

export { BrutalInput };
